import React, { FC, useContext, useState } from 'react'

import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Button, Modal } from 'semantic-ui-react'

import { GlobalContext } from '../../contexts/GlobalContext'

const ExitWithoutSavingChangeModal: FC<IProps> = ({ history }) => {
  const { showExitWithoutSavingModal, dispatchGlobalContext, saveBeforeExit, canSaveBeforeExit } =
    useContext(GlobalContext)
  const [saving, setSaving] = useState(false)

  const exitWithoutSaving = () => {
    dispatchGlobalContext({ type: 'set user has made changes', payload: false })
    dispatchGlobalContext({ type: 'set exit without saving modal', payload: null })

    history.push(`${showExitWithoutSavingModal}`)
  }

  const handleSaveAndExit = async () => {
    setSaving(true)

    let saved = false

    try {
      saved = await saveBeforeExit()
    } catch (error) {
      alert('Your changes could not be saved. Please try again.')
    }

    setSaving(false)
    if (!saved) return

    dispatchGlobalContext({ type: 'set user has made changes', payload: false })
    dispatchGlobalContext({ type: 'set exit without saving modal', payload: null })
    history.push(`${showExitWithoutSavingModal}`)
  }

  return (
    <Modal open={!!showExitWithoutSavingModal} size="small">
      <Modal.Header>Unsaved changes</Modal.Header>
      <Modal.Content>
        <p>Some changes have been made on this page. Would you like to save them before leaving?</p>
      </Modal.Content>
      <Modal.Actions>
        <Button
          disabled={saving}
          onClick={() => dispatchGlobalContext({ type: 'set exit without saving modal', payload: null })}
        >
          Cancel
        </Button>
        <Button disabled={saving} onClick={exitWithoutSaving}>
          Exit without saving
        </Button>
        {canSaveBeforeExit && (
          <Button primary loading={saving} onClick={handleSaveAndExit}>
            Save
          </Button>
        )}
      </Modal.Actions>
    </Modal>
  )
}

interface IProps extends RouteComponentProps<any> {}

export default withRouter(ExitWithoutSavingChangeModal)
